import React, { useState, useEffect } from 'react';

// mui material
import {
    Box,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Tooltip
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterListTwoTone';
import SearchIcon from '@mui/icons-material/Search';

// project import
import MainCard from 'ui-component/cards/MainCard';
import PaginationRows from 'ui-component/extended/PaginationRows';
import { TransactionList } from '../../Transaction/TransactionList';
import useApi from 'hooks/useApi';
import TransactionService from 'services/TransactionService';
import Filter from './../../Transaction/Filter';

const Transaction = ({ venueUuid }) => {

    const [total, setTotal] = useState(1);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [limit, setLimit] = useState(10);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [open, setOpen] = useState(false);
    const [filterObj, setFilterObj] = useState({
        start_date: '',
        end_date: '',
        uuid_user: [],
        uuid_venue: [venueUuid],
        status: [],
        transfer_status: [],
        booking_type: []
    });

    const handleCloseDialog = () => {
        setOpen(false);
    };

    const handleClickOpenDialog = () => {
        setOpen(true);
    };

    const handleSuccess = (response) => {
        const data = response.data;
        setRows(data.rows);
        setTotal(data.filtered);
    };

    const transactionListApi = useApi(TransactionService.getTransactionList, handleSuccess);

    useEffect(() => {
        transactionListApi.execute({
            limit,
            skip: (page * limit) - limit,
            searchValue: searchText.trim(),
            filter: filterObj
        });
    }, [searchText, page, limit, reload, filterObj]);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard >
                <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                )
                            }}
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Search..."
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={9} sx={{ textAlign: 'right' }}>
                        <Tooltip title="Filter">
                            <IconButton
                                size="large"
                                onClick={handleClickOpenDialog}
                                sx={{ boxShadow: 'none', ml: 1, width: 32, height: 32, minHeight: 32 }}
                            >
                                <FilterListIcon />
                            </IconButton>
                        </Tooltip>
                        <Filter open={open} handleCloseDialog={handleCloseDialog} filterObj={filterObj} setFilterObj={setFilterObj} viewType="venue" />
                    </Grid>
                </Grid>
                <TransactionList
                    rows={rows}
                    limit={limit}
                    page={page}
                    setReload={setReload}
                    viewType="venue"
                />
                <PaginationRows
                    total={total}
                    page={page}
                    setPage={setPage}
                    limit={limit}
                    setLimit={setLimit}
                    limits={[10, 15, 20]}
                />
            </MainCard>
        </Box>
    )
}

export default Transaction;
